export function fakePlaceholder() {
  const textarea = document.querySelector(".textarea-message");
  const placeholder = document.querySelector(".fake-placeholder");

  function togglePlaceholder() {
    if (document.activeElement === textarea || textarea.value.trim() !== "") {
      placeholder.style.opacity = 0;
    } else {
      placeholder.style.opacity = 1;
    }
  }

  if (textarea) {
    textarea.addEventListener("input", togglePlaceholder);
    textarea.addEventListener("focus", togglePlaceholder);
    textarea.addEventListener("blur", togglePlaceholder);
    togglePlaceholder();
  }
}
